import { Button, Card, Icon } from "materia"
import { useTranslation } from "react-i18next"
import { modifiers } from "ui-tools"
import { useJourneyNavigation } from "../../../tools/useJourneyNavigation"

import s from "./styles.module.scss"

type JourneyNextProps = {
  id: string
  isLocked: boolean
  title: string | null
}
export const JourneyNext = ({ id, isLocked, title }: JourneyNextProps) => {
  const { t } = useTranslation()
  const { navigateToJourney } = useJourneyNavigation()

  const onNextJourneyClick = () => {
    navigateToJourney(id)
  }

  return (
    <Card borderRadius="24">
      <div className={s.content}>
        <div className={s.content__details}>
          <p className={s.content__nextUp}>{t("journey.NEXT_JOURNEY")}</p>
          <div className={modifiers(s, "content__journeyTitle", { isLocked })}>
            {isLocked && <Icon icon="Lock" size="small" />}

            <span>{title}</span>
          </div>
        </div>

        <Button size="big" borderRadius="32" onClick={onNextJourneyClick}>
          {t("journey.CONTINUE_JOURNEY")}
        </Button>
      </div>
    </Card>
  )
}
